// Pagrindiniai duomenys — vienintelis šaltinis visai svetainei
export const SITE = {
  brand: "MANOPIRTIS.LT",
  brandTagline: "architectural sauna studio",
  city: "Klaipėda",
  country: "Lietuva",
  phone: "+370 672 74514",
  phoneHref: "+37067274514",
  email: "info@dimart.lt",
  facebook: "https://facebook.com",
  instagram: "https://instagram.com",
  seasonNote: "Vienu metu priimu ribotą projektų skaičių, kad galėčiau asmeniškai užtikrinti kokybę kiekviename etape.",
  authorQuote: "Autorinė mažoji architektūra – nuo idėjos iki atsakingo įgyvendinimo.",
  philosophyShort:
    "Karkasinės pirtys ir mažosios architektūros objektai, kuriuose susijungia funkcija, estetika ir pagarba detalėms.",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_timber-spaces/artifacts/yk9ephds_Logo%20Option%20B.png";

export const ASSETS = {
  hero: "https://customer-assets.emergentagent.com/job_c572d028-b301-4685-af5d-2352303bfa9f/artifacts/bqliw7eg_2%20var%202.jpg",
  authorPortrait:
    "https://images.pexels.com/photos/5589950/pexels-photo-5589950.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  finalBg:
    "https://images.unsplash.com/photo-1613140957706-36e7299745b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  solo: "https://customer-assets.emergentagent.com/job_c572d028-b301-4685-af5d-2352303bfa9f/artifacts/ina7p45v_1var%201a.jpg",
  soloAlt:
    "https://customer-assets.emergentagent.com/job_c572d028-b301-4685-af5d-2352303bfa9f/artifacts/xitxik80_1var%202a.jpg",
  balance:
    "https://customer-assets.emergentagent.com/job_c572d028-b301-4685-af5d-2352303bfa9f/artifacts/hdebfimy_2%20var%201.jpg",
  balanceAlt:
    "https://customer-assets.emergentagent.com/job_c572d028-b301-4685-af5d-2352303bfa9f/artifacts/bqliw7eg_2%20var%202.jpg",
  grand:
    "https://customer-assets.emergentagent.com/job_c572d028-b301-4685-af5d-2352303bfa9f/artifacts/3sfdhnia_2%20var%203.jpg",
};

export const NAV_LINKS = [
  { to: "/", label: "Pagrindinis" },
  { to: "/autorius", label: "Apie mane" },
  { to: "/projektai", label: "Projektai" },
  { to: "/standartas", label: "Standartas" },
  { to: "/kainos", label: "Kainos" },
  { to: "/kontaktai", label: "Kontaktai" },
];

export const PROJECTS = [
  {
    id: "solo",
    slug: "solo",
    label: "01 — SOLO",
    name: "SOLO pirtis",
    area: "8 m²",
    dims: "1,9 × 2,2 m",
    tagline: "Asmeninė erdvė poilsiui ir atsikvėpimui",
    priceFrom: "nuo 8 900 €",
    priceShort: "Mažoji pirtis",
    priceNote:
      "Kompaktiškas sprendimas tiems, kurie vertina paprastumą, funkcionalumą ir jaukumą.",
    cover: ASSETS.solo,
    gallery: [ASSETS.solo, ASSETS.soloAlt],
    intro:
      "Kompaktiška pirtis dviem ar nedidelei kompanijai. Sukurta tiems, kurie vertina privatumą, jaukumą ir maksimalų funkcionalumą nedidelėje erdvėje.",
    bullets: [
      "Pirties išmatavimai 1,9 × 2,2 m",
      "Kompaktiška ir jauki",
      "Puikiai tinka mažam sklypui",
      "Maksimaliai išnaudota erdvė",
      "Greitai įkaista",
      "Mini poilsio terasa",
      "Panoraminis langas",
      "Sukuria išskirtinį privatumo ir ramybės pojūtį",
    ],
    idea: "Asmeninė erdvė poilsiui ir atsikvėpimui.",
  },
  {
    id: "balance",
    slug: "balance",
    label: "02 — BALANCE",
    name: "BALANCE pirtis",
    area: "12 m²",
    dims: "—",
    tagline: "Pusiausvyra tarp kompaktiškumo ir komforto",
    priceFrom: "nuo 12 900 €",
    priceShort: "Vidutinė pirtis",
    priceNote:
      "Subalansuotas variantas šeimai – daugiau erdvės, daugiau galimybių individualiems sprendimams.",
    cover: ASSETS.balance,
    gallery: [ASSETS.balance, ASSETS.balanceAlt],
    intro: "Optimalus dydžio, komforto ir kainos balansas.",
    bullets: [
      "Subalansuotas sprendimas kasdieniam naudojimui",
      "Erdvus pirties kambarys",
      "Patogus priepirčio plotas",
      "Didelis langas pirties zonoje",
      "Šiuolaikiškas komfortas",
      "Puikiai tinka šeimai ir draugams",
    ],
    idea: "Pusiausvyra tarp kompaktiškumo ir komforto.",
  },
  {
    id: "grand",
    slug: "grand",
    label: "03 — GRAND",
    name: "GRAND pirtis",
    area: "27 m²",
    dims: "—",
    tagline: "Daugiau nei pirtis – pilnavertė poilsio erdvė",
    priceFrom: "nuo 16 900 €",
    priceShort: "Didžioji pirtis",
    priceNote:
      "Pilnavertis mažosios architektūros objektas su erdvia poilsio zona ir išskirtine atmosfera.",
    cover: ASSETS.grand,
    gallery: [ASSETS.grand, ASSETS.balance],
    intro:
      "Pilnavertis architektūrinis objektas tiems, kurie ieško ne tik pirties, bet ir visapusiškos poilsio erdvės. Sukurta ilgesniam poilsiui, bendravimui ir tikram pirties ritualui.",
    bullets: [
      "Erdvi pirties zona su panoraminiu langu",
      "Patogi poilsio erdvė",
      "Dušas",
      "Tualetas",
      "Funkcionalus ir apgalvotas išplanavimas",
      "Šiuolaikinio pirties ritualo atmosfera",
      "Puikiai tinka šeimai, draugų susibūrimams ar svečių priėmimui",
    ],
    idea: "Daugiau nei pirtis – pilnavertė poilsio erdvė jūsų sklype.",
  },
];

export const PRICING_FACTORS = [
  "pasirinktas pirties modelis ir jo dydis",
  "vidaus ir išorės apdailos lygis",
  "krosnies tipas – malkinė arba elektrinė",
  "langų ir durų sprendimai (PVC arba aliuminio sistemos)",
  "papildoma įranga ir pasirinktos opcijos",
  "montavimo sąlygos ir sklypo specifika",
];

export const STANDARDS = [
  {
    id: "grindys",
    icon: "Grid3x3",
    title: "Plytelių grindys – ilgaamžiškas sprendimas",
    body: [
      "Daugelyje mažų pirčių grindims naudojamos medinės lentos. Tačiau nuolatinė drėgmė ir vandens poveikis ilgainiui gali turėti įtakos jų ilgaamžiškumui.",
      "Todėl ManoPirtis grindims naudojamos keraminės plytelės, montuojamos ant cementinių plokščių pagrindo. Suformuojamas reikiamas nuolydis vandens nubėgimui, atliekama hidroizoliacija, ir tik tuomet klijuojamos plytelės.",
      "Tai praktiškas, higieniškas ir ilgaamžis sprendimas, pritaikytas tikram naudojimui.",
    ],
  },
  {
    id: "siltinimas",
    icon: "Layers",
    title: "Atsakingai suprojektuotas šiltinimas",
    body: [
      "Standartinėje ManoPirtis komplektacijoje naudojama 150 mm sienų konstrukcija su kryžminiu šiltinimu, kuris sumažina šalčio tiltelių susidarymą ir pagerina šilumines savybes.",
      "Esant poreikiui, gali būti pasirenkami ir ekonomiškesni sprendimai, pritaikyti individualiam biudžetui bei naudojimo pobūdžiui.",
    ],
  },
  {
    id: "izoliacija",
    icon: "Flame",
    title: "Papildoma pirties zonos izoliacija",
    body: [
      "Pirties zonoje naudojama papildoma speciali šilumą atspindinti izoliacija, skirta būtent saunoms.",
      "Visos siūlės kruopščiai sandarinamos aliuminio juosta, padedančia efektyviau išlaikyti šilumą ir apsaugoti konstrukciją.",
    ],
  },
  {
    id: "detales",
    icon: "Compass",
    title: "Apgalvotos detalės",
    body: [
      "Prie krosnies naudojamos karščiui atsparios medžiagos ir plytelių apdaila. Interjero sprendimai kuriami taip, kad funkcionalumas ir estetika papildytų vienas kitą.",
      "Kiekviena detalė turi savo paskirtį ir yra apgalvota.",
    ],
  },
  {
    id: "sviesa",
    icon: "Lightbulb",
    title: "Šviesa ir atmosfera",
    body: [
      "Integruotas LED apšvietimas kuriamas ne tik funkcijai, bet ir nuotaikai.",
      "Mums svarbu ne tik tai, kaip erdvė atrodo, bet ir kaip joje jaučiasi žmogus.",
    ],
  },
  {
    id: "pasirinkimai",
    icon: "SlidersHorizontal",
    title: "Individualūs pasirinkimai",
    body: [
      "Kiekvienas projektas gali būti pritaikytas individualiai.",
    ],
    bullets: [
      "malkinę arba elektrinę krosnį",
      "PVC arba aliuminio langų sistemas",
      "skirtingus apdailos sprendimus",
      "papildomas opcijas pagal savo poreikius",
    ],
    footer:
      "Prisitaikant prie individualių pasirinkimų visuomet išlaikoma pagrindinė ManoPirtis architektūrinė idėja – funkcionalumas, estetika ir pagarba detalėms.",
  },
];

export const STANDARD_QUOTE =
  "Mes nestatome daug. Mes statome taip, kaip statytume sau.";
